import { DialogObject, useDialog } from "../composables/dialog";
import { WrappableDialog } from "../vue";
import { router } from "../router";
import { handlingError } from "./component";

// ENG-16120 disable main app content while any modal is open
// JAWS screen reader escaped focus
export function toggleAppInertState(isModalOpen, targetElement) {
  const appEl = targetElement?.value;

  if (!appEl) {
    return;
  }

  if (isModalOpen) {
    // Disable main app content, not #modal
    appEl?.setAttribute("aria-hidden", "true");
    appEl?.setAttribute("inert", "");
  } else {
    // Disable main app content, #modal empty
    appEl.removeAttribute("aria-hidden");
    appEl.removeAttribute("inert");
  }
}

export function showDialog<O extends Exclude<DialogObject, "resolve" | "reject">>(
  options: Partial<O>,
): WrappableDialog<O> {
  const r = useDialog();

  // @ts-expect-error not fully correct inferred type
  const dialog = (r.value = {
    // zIndex,
    type: "dialog",
    ariaLive: options.ariaLive,
    wrapperClass: handlingError ? "dialog-warning" : undefined,
    contentClass: options.text ? "whitespace-pre-wrap" : undefined,
    small: false,
    ...options,
    router,

    resolve(...args: any[]) {
      successCb.forEach((x) => x(...args));
      r.value = undefined;
    },
    reject(...args: any[]) {
      rejectCb.forEach((x) => x(...args));
      r.value = undefined;
    },
  });

  const successCb: Array<(...args: any[]) => void> = [];
  const rejectCb: Array<(...args: any[]) => void> = [];

  return {
    options,

    onOk(cb: () => void) {
      successCb.push(cb);
      return this;
    },
    onCancel(cb: () => void) {
      rejectCb.push(cb);
      return this;
    },
    onFinally(cb: () => void) {
      successCb.push(cb);
      rejectCb.push(cb);
      return this;
    },
    close() {
      // @ts-expect-error not fully correct inferred type
      dialog.close?.();
    },
  };
}

// ENG-15172, WCAG landmark corrections
export function landmarkDateMenu(el, matchID: string, ariaLabel: string = "Date picker") {
  const portal = el.closest(`[id^="${matchID}"]`) as HTMLElement | null;
  if (!portal) return;

  // Make the portal a landmark (named region)
  if (!portal.hasAttribute("role")) portal.setAttribute("role", "region");
  if (!portal.hasAttribute("aria-label") && !portal.hasAttribute("aria-labelledby")) {
    portal.setAttribute("aria-label", ariaLabel);
  }
}

export async function announceDialogContent(msg: string, delay = 50) {
  const el = document.getElementById("status-messages");
  if (!el) return;

  // el.textContent = "";
  setTimeout(() => {
    el.textContent = msg;
  }, delay);
}
